import React from 'react';

const VARIANTS = {
  success: 'bg-success-100 text-success-700',
  warning: 'bg-warning-100 text-warning-700',
  danger:  'bg-danger-100 text-danger-700',
  primary: 'bg-primary-100 text-primary-700',
  neutral: 'bg-neutral-200 text-neutral-700',
};

const SIZES = {
  sm: 'text-[10px] px-1.5 py-0.5',
  md: 'text-xs px-2 py-1',
};

const StatusBadge = ({
  children,
  variant = 'neutral',
  size = 'md',
  uppercase = true,
  dot = false,
  className = '',
}) => {
  const v = VARIANTS[variant] || VARIANTS.neutral;
  const s = SIZES[size] || SIZES.md;
  const dotColor =
    variant === 'success' ? 'bg-success-500' :
    variant === 'warning' ? 'bg-warning-500' :
    variant === 'danger'  ? 'bg-danger-500'  :
    variant === 'primary' ? 'bg-primary-500' :
    'bg-neutral-400';
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-semibold rounded ${uppercase ? 'uppercase tracking-wide' : ''} ${v} ${s} ${className}`}
    >
      {dot && <span className={`inline-block w-1.5 h-1.5 rounded-full ${dotColor}`} />}
      {children}
    </span>
  );
};

export default StatusBadge;
